import { render, staticRenderFns } from "./historyrouter.vue?vue&type=template&id=fbd3ded0&scoped=true&"
import script from "./historyrouter.vue?vue&type=script&lang=js&"
export * from "./historyrouter.vue?vue&type=script&lang=js&"
import style0 from "./historyrouter.vue?vue&type=style&index=0&id=fbd3ded0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd3ded0",
  null
  
)

component.options.__file = "historyrouter.vue"
export default component.exports